import { input } from '@angular/core';
import * as i0 from "@angular/core";
function UpdateWatchlistConfirmationDetailsComponent_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 0);
    i0.ɵɵtext(1);
    i0.ɵɵdomElementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.details().error);
} }
function UpdateWatchlistConfirmationDetailsComponent_Conditional_1_Conditional_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 2)(1, "span", 3);
    i0.ɵɵtext(2, "Rename to:");
    i0.ɵɵdomElementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵdomElementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.details().rename_to);
} }
function UpdateWatchlistConfirmationDetailsComponent_Conditional_1_Conditional_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 2)(1, "span", 3);
    i0.ɵɵtext(2);
    i0.ɵɵdomElementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵdomElementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Adding (", ctx_r0.details().added_symbols.length, "):");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.details().added_symbols.join(", "), " ");
} }
function UpdateWatchlistConfirmationDetailsComponent_Conditional_1_Conditional_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 2)(1, "span", 3);
    i0.ɵɵtext(2);
    i0.ɵɵdomElementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵdomElementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Removing (", ctx_r0.details().removed_symbols.length, "):");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.details().removed_symbols.join(", "), " ");
} }
function UpdateWatchlistConfirmationDetailsComponent_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 1)(1, "div", 2);
    i0.ɵɵtext(2, "Updates for ");
    i0.ɵɵdomElementStart(3, "span", 3);
    i0.ɵɵtext(4);
    i0.ɵɵdomElementEnd();
    i0.ɵɵtext(5, ":");
    i0.ɵɵdomElementEnd();
    i0.ɵɵconditionalCreate(6, UpdateWatchlistConfirmationDetailsComponent_Conditional_1_Conditional_6_Template, 4, 1, "div", 2);
    i0.ɵɵconditionalCreate(7, UpdateWatchlistConfirmationDetailsComponent_Conditional_1_Conditional_7_Template, 4, 2, "div", 2);
    i0.ɵɵconditionalCreate(8, UpdateWatchlistConfirmationDetailsComponent_Conditional_1_Conditional_8_Template, 4, 2, "div", 2);
    i0.ɵɵdomElementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.details().current_name);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.details().rename_to ? 6 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.details().added_symbols.length ? 7 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.details().removed_symbols.length ? 8 : -1);
} }
export class UpdateWatchlistConfirmationDetailsComponent {
    constructor() {
        this.details = input.required(...(ngDevMode ? [{ debugName: "details" }] : []));
    }
}
UpdateWatchlistConfirmationDetailsComponent.ɵfac = function UpdateWatchlistConfirmationDetailsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || UpdateWatchlistConfirmationDetailsComponent)(); };
UpdateWatchlistConfirmationDetailsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: UpdateWatchlistConfirmationDetailsComponent, selectors: [["ycn-update-watchlist-confirmation-details"]], inputs: { details: [1, "details"] }, decls: 2, vars: 1, consts: [[1, "text-large", "leading-relaxed", "mb-3", "text-danger"], [1, "text-large", "leading-relaxed", "mb-3"], [1, "mt-2"], [1, "text-bold"]], template: function UpdateWatchlistConfirmationDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵconditionalCreate(0, UpdateWatchlistConfirmationDetailsComponent_Conditional_0_Template, 2, 1, "div", 0)(1, UpdateWatchlistConfirmationDetailsComponent_Conditional_1_Template, 9, 4, "div", 1);
    } if (rf & 2) {
        i0.ɵɵconditional(ctx.details().error ? 0 : 1);
    } }, encapsulation: 2, changeDetection: 0 });
